"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "form-block-margin-top" };
const DetailWideRadio_vue_1 = __importDefault(require("../../../components/frontend/DetailWideRadio.vue"));
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
const ServicesStore_1 = require("../../../stores/services/ServicesStore");
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TyreFitting',
    setup(__props) {
        const errorMessage = (0, vue_3.ref)("");
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        const servicesStore = (0, ServicesStore_1.useServicesStore)();
        (0, vue_3.watch)(() => [
            bookAppointmentStore.reservedServiceLocationId,
            bookAppointmentStore.tyreDatas.tyreDiameter,
        ], ([newServiceId, newTyreDiameter]) => {
            if (newServiceId !== null && newTyreDiameter !== null) {
                servicesStore
                    .getServices(newServiceId, newTyreDiameter)
                    .then(() => {
                    bookAppointmentStore.tyreFittingServiceSKU = null;
                    errorMessage.value = "";
                })
                    .catch((error) => {
                    bookAppointmentStore.tyreFittingServiceSKU = null;
                    errorMessage.value = error.toString();
                });
            }
        }, { immediate: true });
        const changeService = (serviceSku) => {
            bookAppointmentStore.tyreFittingServiceSKU = serviceSku;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (errorMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: errorMessage.value,
                        icon: ""
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(servicesStore).services, (service, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DetailWideRadio_vue_1.default, {
                            key: index,
                            name: "csomag",
                            title: service.name,
                            text: service.description,
                            price: service.price,
                            class: "tyre-service",
                            onChange: ($event) => (changeService(service.id))
                        }, null, 8, ["title", "text", "price", "onChange"]));
                    }), 128))
                ])
            ], 64));
        };
    }
});
